/* global html2canvas, X */

X.Capture = function() {
    'use strict'
    this.VERSION = '0.0.2'
    this._html2canvasOptions = { logging: !1, allowTaint: !1, useCORS: !0, async: !1 }
    this._exclusionIDList = []
    this._canvas = null
    this._containerName = ''
    this.className = {
        PANE: 'leaflet-map-pane',
        MARKER: 'leaflet-marker-icon',
        CONTROL: 'leaflet-control-container',
        TILE: 'leaflet-tile leaflet-tile-loaded'
    }
    this.setOptions = function(n) {
        n && (this._html2canvasOptions = n)
    }
    this.setExclusionIDList = function(n) {
        n && (this._exclusionIDList = n)
    }
    this.parseTrans3d = function(n) {
        var i = /translate(|3d)\((.*?)\)/g.exec(n),
            r = null,
            u = null,
            t
        return i
            ? (
                  (t = i[2].split(',')),
                  (r = parseFloat(t[0])),
                  (u = parseFloat(t[1])),
                  { x: r, y: u }
              )
            : null
    }
    this.convertTrans3d = function(n, t) {
        for (var r, i = 0; i < n.length; i++) {
            if (((r = n[i].style.transform), this._exclusionIDList.indexOf(n[i]) != -1)) return !1
            if (r && r.includes('translate')) {
                t.push(n[i].style.cssText)
                var u = this.parseTrans3d(r),
                    f = 0,
                    e = 0
                n[i].style.marginLeft && (f = parseInt(n[i].style.marginLeft, 10))
                n[i].style.marginTop && (e = parseInt(n[i].style.marginTop, 10))
                n[i].style.left = u.x + f + 'px'
                n[i].style.top = u.y + e + 'px'
                n[i].style.marginLeft = 0
                n[i].style.marginTop = 0
                n[i].style.transform = 'none'
            } else {
                t.push('')
            }
        }
        return !0
    }
    this.restore2trans3d = function(n, t) {
        for (var i = 0; i < n.length; i++) {
            if (this._exclusionIDList.indexOf(n[i].id) != -1) return !1
            n[i].style.cssText = t[i]
        }
        return (t = []), !0
    }
    this.capture = function(n, t, i) {
        var r = document.getElementById(n),
            u,
            f
        if (r) this._containerName = n
        else return !1
        u = this
        f = !0
        f = t
        var o = this.className.PANE,
            s = this.className.TILE,
            h = this.className.MARKER,
            e = r.getElementsByClassName(this.className.CONTROL)[0]
        if (f && e) {
            e.style.display = 'none'
        }
        var c = [],
            l = [],
            a = [],
            v = [],
            y = [],
            g = []
        this.convertTrans3d(r.getElementsByClassName(o), c)
        this.convertTrans3d(r.getElementsByClassName(s), l)
        this.convertTrans3d(r.getElementsByClassName(h), a)
        this.convertTrans3d(r.getElementsByTagName('svg'), v)
        this.convertTrans3d(r.getElementsByTagName('canvas'), y)
        this.convertTrans3d(r.getElementsByClassName('leaflet-image-layer'), g)
        html2canvas(r, this._html2canvasOptions).then(function(n) {
            u._canvas = n
            u.restore2trans3d(r.getElementsByClassName(o), c)
            u.restore2trans3d(r.getElementsByClassName(s), l)
            u.restore2trans3d(r.getElementsByClassName(h), a)
            u.restore2trans3d(r.getElementsByTagName('svg'), v)
            u.restore2trans3d(r.getElementsByTagName('canvas'), y)
            u.restore2trans3d(r.getElementsByClassName('leaflet-image-layer'), g)
            f && e && (e.style.display = 'block')
            i && i()
        })
    }
    this.getCanvas = function() {
        return this._canvas
    }
    this.save = function(n, t) {
        var h = this._canvas,
            c = document.getElementById('test'),
            u = 'xCapture.png',
            f,
            e,
            r,
            o,
            s,
            i
        n && (u = n)
        f = 'image/png'
        t && (f = t)
        e = h.toDataURL(f)
        r = window.navigator.userAgent
        r.indexOf('MSIE ') > 0 || r.indexOf('Trident/') > 0 || r.indexOf('Edge') > 0
            ? (
                  (o = function(n) {
                      for (var r = atob(n.split(',')[1]), u = [], i = 0; i < r.length; i++)
                          u.push(r.charCodeAt(i))
                      return new Blob([new Uint8Array(u)], { type: t })
                  }),
                  (s = o(e)),
                  window.navigator.msSaveOrOpenBlob(s, u)
              )
            : (
                  (i = document.createElement('a')),
                  (i.text = 'Download'),
                  i.setAttribute('download', u),
                  i.addEventListener('click', function() {
                      i.href = e
                  }),
                  document.body.appendChild(i),
                  i.click(),
                  document.body.removeChild(i)
              )
    }
}
